import { Roles } from './components';

export function AccountRolesContent() {
  return <Roles />;
}
